import { Component, computed, inject, input } from '@angular/core';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { CoreJssProxyModule } from '@core/jss-proxy';

import { HeroButtonGroupComponent } from '../hero-button-group/hero-button-group.component';
import type { Hero } from '../models/hero.model';
import { HeroFieldService } from '../services/hero-field.service';

@Component({
  selector: 'wl-hero-heading',
  standalone: true,
  imports: [HeroButtonGroupComponent, CoreJssProxyModule],
  templateUrl: './hero-heading.component.html',
  styleUrls: [
    './hero-heading.component.essent.scss',
    './hero-heading.component.ed.scss',
  ],
})
export class HeroHeadingComponent {
  readonly #heroFieldService = inject(HeroFieldService);

  readonly hero = input.required<Partial<Hero>>();
  readonly hasEssentRebranding = input<boolean>(false);

  private readonly brand = inject(ENVIRONMENT_CONFIG).brand;

  private readonly isEd = computed(() => this.brand === 'ed');

  readonly headingLine1 = computed(() => this.hero().headingLine1);
  readonly headingLine2 = computed(() => this.hero().headingLine2);

  readonly showButtonGroup = computed(
    () => this.isEd() && this.#heroFieldService.showButtonGroup(this.hero())
  );
}
